import React from "react";
import { FormControl, FormHelperText, Grid, ListItem } from "@material-ui/core";
import ListItemText from "@material-ui/core/ListItemText";
import List from "@material-ui/core/List";
import { getShortFileSize } from "../../helpers/converters/fileHelpers";
import { FileUploader, FileUploadProps } from "../../app/components/ui/file-upload-button/FileUploadButton";

import classes from './index.module.scss';

export type FakeFile = {
  name: string;
  size: number;
}

export type SelectFileProps = {
  selectedFile?: File | FakeFile;
  error?: string;
  disabled?: boolean;
} & FileUploadProps;

const SelectFile = (props: SelectFileProps) => {
  const name = props.selectedFile?.name || '';
  const size = getShortFileSize(props.selectedFile?.size || 0);

  return (
    <Grid
      container
      spacing={2}
    >
      <Grid container item xs={3}>
        <FormControl
          variant="outlined"
          disabled={props.disabled}
          error={Boolean(props.error)}
        >
          <FileUploader {...props} />
          <FormHelperText error>{props.error}</FormHelperText>
        </FormControl>
      </Grid>
      <Grid item xs={9}>
        {
          props.selectedFile ? (
            <List className={classes.fileInfo}>
              <ListItem className={classes.fileLine}>
                <ListItemText
                  primary={name}
                  secondary={size}
                />
              </ListItem>
            </List>
          ) : null
        }
      </Grid>
    </Grid>
  )
}

export default SelectFile;